import { SectionHeader } from '../rows/SectionHeader'
import { getStatusColor, CompletionBadge } from '@/components/ui/metrics'
import type { MonthMetrics } from '@/features/history/types'

interface TotalsSectionProps {
  metrics: MonthMetrics
  weeklyAvg: (v: number) => number
  formatCurrency: (v: number) => string
  formatRefund: (v: number) => string
}

export function TotalsSection({ metrics, weeklyAvg, formatCurrency, formatRefund }: TotalsSectionProps) {
  const { other_income: other, refunds, gross_revenue: revenue } = metrics
  return (
    <>
      <SectionHeader label="Прочее" color="gray" />
      <tr className="border-b border-border hover:bg-muted/30 transition-colors">
        <td className="p-3 pl-6 text-sm">Прочие доходы</td>
        <td className="p-3 text-right font-mono text-sm">{formatCurrency(weeklyAvg(other.plan))}</td>
        <td className={`p-3 text-right font-mono text-sm ${getStatusColor(other.completion, other.plan)}`}>
          {formatCurrency(weeklyAvg(other.fact))}
        </td>
        <td className="p-3 text-right font-mono text-sm">{formatCurrency(other.plan)}</td>
        <td className={`p-3 text-right font-mono text-sm font-semibold ${getStatusColor(other.completion, other.plan)}`}>
          {formatCurrency(other.fact)}
        </td>
        <td className={`p-3 text-center ${getStatusColor(other.completion, other.plan)}`}>
          <CompletionBadge metric={other} />
        </td>
      </tr>
      <tr className="border-b border-border hover:bg-muted/30 transition-colors">
        <td className="p-3 pl-6 text-sm">Возвраты</td>
        <td className="p-3 text-right font-mono text-sm text-red-600">
          {formatRefund(weeklyAvg(refunds.plan))}
        </td>
        <td className="p-3 text-right font-mono text-sm font-semibold text-red-600">
          {formatRefund(weeklyAvg(refunds.fact))}
        </td>
        <td className="p-3 text-right font-mono text-sm text-red-600">
          {formatRefund(refunds.plan)}
        </td>
        <td className="p-3 text-right font-mono text-sm font-semibold text-red-600">
          {formatRefund(refunds.fact)}
        </td>
        <td className={`p-3 text-center ${getStatusColor(refunds.completion, Math.abs(refunds.plan))}`}>
          <CompletionBadge metric={refunds} />
        </td>
      </tr>

      <SectionHeader label="Итого" color="green" />
      <tr className="border-b border-border hover:bg-muted/30 transition-colors">
        <td className="p-3 pl-6 text-sm font-semibold">Выручка общая</td>
        <td className="p-3 text-right font-mono text-sm font-semibold">{formatCurrency(weeklyAvg(revenue.plan))}</td>
        <td className={`p-3 text-right font-mono text-sm font-semibold ${getStatusColor(revenue.completion, revenue.plan)}`}>
          {formatCurrency(weeklyAvg(revenue.fact))}
        </td>
        <td className="p-3 text-right font-mono text-sm font-semibold">{formatCurrency(revenue.plan)}</td>
        <td className={`p-3 text-right font-mono text-sm font-semibold ${getStatusColor(revenue.completion, revenue.plan)}`}>
          {formatCurrency(revenue.fact)}
        </td>
        <td className={`p-3 text-center ${getStatusColor(revenue.completion, revenue.plan)}`}>
          <CompletionBadge metric={revenue} />
        </td>
      </tr>
    </>
  )
}
